import {Component, HostBinding} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {version} from 'packageJson';
@Component({
  standalone: true,
  imports: [RouterOutlet],
  selector: 'cdh-root',
  template: '<router-outlet />',
})
export class AppComponent {
  @HostBinding('attr.app-version') appVersion = version;
  title = 'cdh-new';
}
